/** @jsxImportSource @emotion/react */

import type { ElementType } from "react";
import {
  baseCss,
  fullWidthCss,
  sizeStyles,
  socialVariants,
  withTextCss,
} from "./SocialLoginButton.css";
import * as icons from "./SocialLoginButton.icons";
import type { SocialLoginButtonProps } from "./SocialLoginButton.types";

export function SocialLoginButton<Element extends ElementType>(
  props: SocialLoginButtonProps<Element>,
) {
  const { as: Element = "button", native, variant, size = "medium", sx, ...restProps } = props;
  const icon = icons[props.variant];
  const commonStyles = [baseCss, socialVariants[variant]];

  // with text
  if ("text" in props && props.text) {
    const { text, fullWidth } = props;
    return (
      <Element
        css={[...commonStyles, withTextCss, sizeStyles[size], fullWidth && fullWidthCss, sx]}
        {...restProps}
        {...native}
      >
        {icon}
        {text}
      </Element>
    );
  }

  // icon only
  return (
    <Element css={[...commonStyles, sizeStyles[`${size}-icon`], sx]} {...restProps} {...native}>
      {icon}
    </Element>
  );
}
